<template>
  <send-to-moderation-button
    v-if="!isOperationHidden(tariff?.operations.sendInWork)"
    :disabled="isOperationDisabled(tariff?.operations.sendInWork)"
    @error="onError"
    @success="onSuccess"
  />

  <operation-button
    v-if="tariff?.remoteInteraction"
    variant="primary"
    class="ml-auto"
    prepend-icon-src="editPen"
    :operation="tariff?.operations.update"
    :to="
      tariff?.remoteInteraction
        ? {
            name: RouteNames.CMEdit,
            query: {
              interactionId: tariff.remoteInteraction.interactionId,
              manager: tariff.remoteInteraction.channelManagerCode,
              t_id: $route.params.t_id,
            },
          }
        : undefined
    "
  >
    Редактировать
  </operation-button>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { type TariffType } from '../store/tariffs';
import OperationButton from '@/core/components/buttons/OperationButton.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { isOperationDisabled, isOperationHidden } from '@/core/utils/permissions';
import SendToModerationButton from '@/parts/tariffs/components/SendToModerationButton.vue';

defineProps<{
  tariff: TariffType;
}>();

const emit = defineEmits<{
  (event: 'error', error: string): void;
  (event: 'success'): void;
}>();

const $route = useRoute();

const onError = (error: string) => {
  emit('error', error);
};

const onSuccess = () => {
  emit('success');
};
</script>
